import { Recaptcha } from '../utils/recaptcha'
import { module } from 'modujs'

const CLASS = {
    IS_SUCCESS: 'is-success',
    IS_LOADING: 'is-loading',
    IS_ERROR: 'is-error'
}

export default class extends module {
    constructor(m) {
        super(m)

        this.events = {
            submit: 'submit',
        }
    }

    init() {
        this.confirmMessage = this.getData('confirm-message')
        this.errorMessage = this.getData('error-message')
        this.feedbackEl = this.$('feedback')[0]
    }

    /**
     * @param {none}
     */
    setLoadingState(state) {
        this.isSubmitting = state
        this.el.classList.toggle(CLASS.IS_LOADING, state)
    }

    /**
     * Set confirmation state & display confirmation message
     *
     * @param {string} | confirmation message
     */
    setConfirmationState(message) {
        this.clearState()

        this.el.reset()

        this.el.classList.add(CLASS.IS_SUCCESS)
        if (this.feedbackEl) {
            this.feedbackEl.innerHTML = message
        }

        this.updateScroll()
    }

    /**
     * Set error state
     *
     * @param {message} | form error message
     */
    setErrorState(message) {
        this.clearState()

        this.el.classList.add(CLASS.IS_ERROR)
        if (this.feedbackEl) {
            this.feedbackEl.innerHTML = message
        }

        this.updateScroll()
    }

    /**
     * Clear all state
     *
     * @param
     */
    clearState() {
        this.el.classList.remove(CLASS.IS_SUCCESS, CLASS.IS_LOADING, CLASS.IS_ERROR)

        if (this.feedbackEl) {
            this.feedbackEl.innerHTML = ""
        }

        this.updateScroll()
    }

    /**
     * In case of use of locomotive-scroll, we need to update page height
     *
     * @param {none}
     */
    updateScroll() {
        requestAnimationFrame(() => { this.call('update', null, 'Scroll') })
    }

    /**
     * Custom submit
     *
     * @param {event}
     */
    submit(event) {
        try {
            event.preventDefault()

            const form = event.target
            const recaptchaElement = form.querySelector('.js-recaptcha-response')

            if (recaptchaElement || !this.isSubmitting) {
                this.clearState()
                this.setLoadingState(true)

                let isError = false

                Recaptcha.setInputElement(recaptchaElement)
                Recaptcha.execute(() => {
                    fetch(form.getAttribute('action'), {
                        method: 'POST',
                        body: new FormData(form),
                    }).then(response => {
                        if (response.status !== 200) {
                            isError = true
                        }
                        return response.json()
                    })
                    .then(response => {
                        if (isError) {
                            this.setErrorState(this.errorMessage)
                        } else {
                            // This is the only way to determine if there was an error since SalesForce always returns 200 OK
                            // if ((response.message || '').includes('success')) {
                            this.setConfirmationState(this.confirmMessage)
                        }
                    })
                    // .catch(() => {
                    // })
                    .finally(() => {
                        this.setLoadingState(false)
                    })
                })
            }
        } catch (error) {
            console.error(error)
        }
    }
}
